import { render, staticRenderFns } from "./DeviceDetailsDialog.vue?vue&type=template&id=10876d28&scoped=true"
import script from "./DeviceDetailsDialog.vue?vue&type=script&lang=js"
export * from "./DeviceDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10876d28",
  null
  
)

export default component.exports